"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringLiteral = exports.DecimalLiteral = exports.IntegerLiteral = exports.BooleanLiteral = exports.Literal = void 0;
var expression_1 = require("./expression");
var Literal = /** @class */ (function (_super) {
    __extends(Literal, _super);
    function Literal(json) {
        var _this = _super.call(this, json) || this;
        _this.valueType = json.valueType;
        _this.value = json.value;
        return _this;
    }
    Literal.from = function (json) {
        switch (json.valueType) {
            case '{urn:hl7-org:elm-types:r1}Boolean':
                return new BooleanLiteral(json);
            case '{urn:hl7-org:elm-types:r1}Integer':
                return new IntegerLiteral(json);
            case '{urn:hl7-org:elm-types:r1}Decimal':
                return new DecimalLiteral(json);
            case '{urn:hl7-org:elm-types:r1}String':
                return new StringLiteral(json);
            default:
                return new Literal(json);
        }
    };
    Literal.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.value];
            });
        });
    };
    return Literal;
}(expression_1.Expression));
exports.Literal = Literal;
// The following are not defined in ELM, but helpful for execution
var BooleanLiteral = /** @class */ (function (_super) {
    __extends(BooleanLiteral, _super);
    function BooleanLiteral(json) {
        var _this = _super.call(this, json) || this;
        _this.value = _this.value === 'true';
        return _this;
    }
    Object.defineProperty(BooleanLiteral.prototype, "isBooleanLiteral", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    BooleanLiteral.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.value];
            });
        });
    };
    return BooleanLiteral;
}(Literal));
exports.BooleanLiteral = BooleanLiteral;
var IntegerLiteral = /** @class */ (function (_super) {
    __extends(IntegerLiteral, _super);
    function IntegerLiteral(json) {
        var _this = _super.call(this, json) || this;
        _this.value = parseInt(_this.value, 10);
        return _this;
    }
    Object.defineProperty(IntegerLiteral.prototype, "isIntegerLiteral", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    IntegerLiteral.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.value];
            });
        });
    };
    return IntegerLiteral;
}(Literal));
exports.IntegerLiteral = IntegerLiteral;
var DecimalLiteral = /** @class */ (function (_super) {
    __extends(DecimalLiteral, _super);
    function DecimalLiteral(json) {
        var _this = _super.call(this, json) || this;
        _this.value = parseFloat(_this.value);
        return _this;
    }
    Object.defineProperty(DecimalLiteral.prototype, "isDecimalLiteral", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    DecimalLiteral.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.value];
            });
        });
    };
    return DecimalLiteral;
}(Literal));
exports.DecimalLiteral = DecimalLiteral;
var StringLiteral = /** @class */ (function (_super) {
    __extends(StringLiteral, _super);
    function StringLiteral(json) {
        return _super.call(this, json) || this;
    }
    Object.defineProperty(StringLiteral.prototype, "isStringLiteral", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    StringLiteral.prototype.exec = function (_ctx) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // TODO: Remove these replacements when CQL-to-ELM fixes bug: https://github.com/cqframework/clinical_quality_language/issues/82
                return [2 /*return*/, this.value.replace(/\\'/g, "'").replace(/\\"/g, '"')];
            });
        });
    };
    return StringLiteral;
}(Literal));
exports.StringLiteral = StringLiteral;
//# sourceMappingURL=literal.js.map